'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

exports.init = init;

var _utils = require('../utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Ticker = function () {
  function Ticker(_ref) {
    var el = _ref.el,
        context = _ref.context;
    (0, _classCallCheck3.default)(this, Ticker);

    this.el = el;
    this.context = context;

    this.isTicking = false;
    this.lastKnownY = 0;
    this.translateAmount = 150;

    this.listEnterPoint = this.getListEnterPoint();

    this.onScroll = this.onScroll.bind(this);
    this.updateEl = this.updateEl.bind(this);

    this.setupListeners();
  }

  (0, _createClass3.default)(Ticker, [{
    key: 'setupListeners',
    value: function setupListeners() {
      window.addEventListener('scroll', this.onScroll);
    }
  }, {
    key: 'onScroll',
    value: function onScroll() {
      this.lastKnownY = window.pageYOffset;

      this.requestTick();
    }
  }, {
    key: 'requestTick',
    value: function requestTick() {
      if (!this.isTicking) requestAnimationFrame(this.updateEl);

      // If a rAF is already queued we don't want to call another one
      this.isTicking = true;
    }
  }, {
    key: 'updateEl',
    value: function updateEl() {
      // Reset the tick so we can capture the next onScroll
      this.isTicking = false;

      if (!this.isVisible) return;

      this.els.list.style.transform = 'translateY(' + this.currentTranslateAmount + 'px)';
    }
  }, {
    key: 'getListEnterPoint',
    value: function getListEnterPoint() {
      return this.els.list.getBoundingClientRect().top + window.pageYOffset - window.innerHeight - this.translateAmount;
    }
  }, {
    key: 'currentTranslateAmount',
    get: function get() {
      if (this.lastKnownY < this.listEnterPoint) return this.translateAmount;
      if (this.lastKnownY > this.listExitsPoint) return -this.translateAmount;

      var totalTranslateAmount = this.translateAmount * 2;
      var visibleAmount = this.listExitsPoint - this.listEnterPoint;
      var currentScrollAmountAsPercentage = (this.lastKnownY - this.listEnterPoint) / visibleAmount;

      return 100 - totalTranslateAmount * currentScrollAmountAsPercentage;
    }
  }, {
    key: 'els',
    get: function get() {
      return {
        el: this.el,
        list: this.context.getElement('.' + this.context.className + '_List')
      };
    }
  }, {
    key: 'isVisible',
    get: function get() {
      return this.lastKnownY >= this.listEnterPoint || this.lastKnownY < this.listExitsPoint;
    }
  }, {
    key: 'listExitsPoint',
    get: function get() {
      return this.listEnterPoint + window.innerHeight + this.els.list.offsetHeight + this.translateAmount;
    }
  }, {
    key: 'offsetTop',
    get: function get() {
      return (0, _utils.getOffsetTop)(this.els.list);
    }
  }]);
  return Ticker;
}();

function init(module) {
  // eslint-disable-next-line no-new
  new Ticker(module);
}